module.exports = __webpack_public_path__ + "media/images/character_design-62ac3823fedac55190f8c0248e598479.jpg";